import { render, staticRenderFns } from "./BaseFrontOfficeDescription.vue?vue&type=template&id=07dd7108&scoped=true"
import script from "./BaseFrontOfficeDescription.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeDescription.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeDescription.vue?vue&type=style&index=0&id=07dd7108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dd7108",
  null
  
)

export default component.exports